module.exports = {"top3":["High out-of-pocket medical spending","Adults who report fair or poor health","Suicide deaths"],"bottom3":["Breast cancer deaths","Mortality amenable to health care","Hospitals with lower-than-average patient experience ratings"],"most_improved":["Home health patients with a hospital admission","Breast cancer deaths","Home health patients without improved mobility"],"most_declined":["Children without all recommended vaccines","Hospital 30-day mortality","Drug poisoning deaths"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/DC.json
// module id = 247
// module chunks = 143196823979170 184088790168614